var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmpty(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 299,
    height: 221,
    viewBox: "0 0 299 221",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: "169.961%",
    x2: "38.532%",
    y1: "-324.054%",
    y2: "125.543%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#44C0FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#B9F9F0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("path", {
    id: "b",
    d: "M73 23.814H47v6.093h-6v-6.093h-5a6 6 0 0 1-6-6V6a6 6 0 0 1 6-6h48a6 6 0 0 1 6 6v11.814a6 6 0 0 1-6 6h-5v6.093h-6v-6.093z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "c",
    d: "M15 21h90v60H15z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "d",
    d: "M33.5 59.75a3.748 3.748 0 0 1-3.75 3.75A3.748 3.748 0 0 1 26 59.75 3.748 3.748 0 0 1 29.75 56a3.748 3.748 0 0 1 3.75 3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "e",
    d: "M119.997 118.25H0C0 112.04 5.039 107 11.25 107h97.497c6.21 0 11.25 5.04 11.25 11.25z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1-40h300v300H-1z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "url(#a)",
    d: "M265.255 151.742C264.59 212.197 215.41 261 154.842 261 93.86 261 44.423 211.527 44.423 150.5c0-5.053.34-10.026.995-14.899H10.933c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933h78.146c5.486 0 9.933-4.447 9.933-9.933a9.936 9.936 0 0 0-6.468-9.311 9.912 9.912 0 0 1-3.464.62H43.19c-5.486 0-9.933-4.447-9.933-9.932 0-5.486 4.447-9.933 9.933-9.933H72.17C92.401 54.401 121.941 40 154.842 40c47.457 0 87.921 29.96 103.537 72.011h31.688c5.486 0 9.933 4.447 9.933 9.933 0 5.485-4.447 9.932-9.933 9.932h-48.371c-5.486 0-9.933 4.447-9.933 9.933s4.447 9.933 9.933 9.933h23.559z",
    transform: "translate(-1 -40)"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 66)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#b"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M73.5 29.407h5v-6.093H84a5.5 5.5 0 0 0 5.5-5.5V6A5.5 5.5 0 0 0 84 .5H36A5.5 5.5 0 0 0 30.5 6v11.814a5.5 5.5 0 0 0 5.5 5.5h5.5v6.093h5v-6.093h27v6.093z"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 95)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#c"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M15.5 21.5h89v59h-89z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#87D5FA",
    fillRule: "nonzero",
    d: "M96.493 125a7.513 7.513 0 0 0 6.248-3.314l1.61-2.398c.807 3.248 3.626 5.712 7.149 5.712 4.146 0 7.5-3.329 7.5-7.442 0 4.114 3.354 7.442 7.5 7.442 4.145 0 7.5-3.329 7.5-7.442 0 4.114 3.354 7.442 7.5 7.442 4.145 0 7.5-3.329 7.5-7.442 0 4.114 3.353 7.442 7.499 7.442 4.145 0 7.5-3.329 7.5-7.442 0 4.114 3.354 7.442 7.5 7.442 4.145 0 7.5-3.329 7.5-7.442 0 4.114 3.354 7.442 7.5 7.442 3.53 0 6.342-2.464 7.147-5.712l1.612 2.398c1.442 2.151 3.823 3.314 6.247 3.314a7.537 7.537 0 0 0 4.153-1.25c3.45-2.282 4.38-6.904 2.08-10.32l-13.74-18.197H104L90.26 113.43c-2.3 3.416-1.362 8.038 2.08 10.32a7.519 7.519 0 0 0 4.153 1.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M111 174v-38h22.5v38z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 95)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#d"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M33 59.75a3.248 3.248 0 0 0-3.25-3.25 3.248 3.248 0 0 0-3.25 3.25A3.248 3.248 0 0 0 29.75 63 3.248 3.248 0 0 0 33 59.75z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#EB8181",
    d: "M141.499 162.5v-26.25h44.999v26.25z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(89 66)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    xlinkHref: "#e"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#64808C",
    d: "M119.485 117.75c-.261-5.703-4.97-10.25-10.738-10.25H11.25C5.483 107.5.773 112.047.51 117.75h118.974z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmpty);
export default __webpack_public_path__ + "static/media/empty.a807a63571716e4d015b9e82ece4d8a4.svg";
export { ForwardRef as ReactComponent };